import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonRadioGroupField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { changeDecorationType } from '../../../state/advanced/decoration';
import { InlineParam, Row } from '../markup';

interface IDecorationProps {
  hasDecoration: boolean | undefined;
  onDecorationChanged(value: boolean | undefined): void;
}

const decoration: React.StatelessComponent<IDecorationProps> = props => {
  return (
    <Row title="Отделка">
      <InlineParam>
        <ButtonRadioGroupField
          uncheckable
          value={String(props.hasDecoration)}
          onValueChange={value => props.onDecorationChanged(value !== undefined ? value === 'true' : undefined)}
          values={[
            { value: 'false', label: 'Без отделки' },
            { value: 'true', label: 'С отделкой' },
          ]}
        />
      </InlineParam>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    hasDecoration: state.filters.jsonQuery.has_decoration && state.filters.jsonQuery.has_decoration.value,
  }),
  (dispatch: Dispatch) => ({
    onDecorationChanged: (value: boolean) => {
      dispatch(changeDecorationType(value));
    },
  }),
)(decoration);
